import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-modal-plans',
  templateUrl: './modal-plans.component.html',
  styleUrls: ['./modal-plans.component.scss'],
})
export class ModalPlansComponent {
  @Input() titleplan!: string;
  @Input() imagen!: string | undefined;
  @Input() iconplan!: string;
  @Input() descriptionplan!: string | undefined;
  @Input() processplan!: string | undefined;
  @Input() idplanCambio!: number;
  @Output() closeModalPlan = new EventEmitter();

  constructor(private router: Router,
  ) {}

  closeModalUpgrade() {
    this.closeModalPlan.emit(false);
  }

  openFormUpgrade() {
    let idPlanCambio = [this.idplanCambio]
    this.router.navigate(['/beneficiaries-form'],{
      queryParams: {
        idPlanCambio,
        data_notification: JSON.stringify({ title: this.titleplan, id_benefit: 86 })
      }}
    );
  }  
}
